import React from 'react';
import 'iconify-icon';

/**
 * Footer section on /franquia/[id] showing legal entity information:
 * Razão Social, CNPJ and Diretor(es)/Franqueado(s). Renders nothing if
 * no legal data is set for the franchise.
 */
export const FranchiseLegal = ({ franchise }) => {
  const { legal_name, cnpj, directors = [] } = franchise || {};
  const hasData = legal_name || cnpj || (directors && directors.length);
  if (!hasData) return null;

  return (
    <section
      className="relative z-10 py-12 border-t border-neutral-900"
      style={{ background: 'rgba(8, 8, 8, 0.92)' }}
      data-testid="franchise-legal-section"
    >
      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-12">
        <span className="text-[10px] font-mono uppercase tracking-[0.3em] text-neutral-500 mb-3 block">
          Dados da empresa
        </span>

        <dl className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
          {legal_name && (
            <div>
              <dt className="text-[10px] font-mono uppercase tracking-widest text-neutral-600 mb-1">
                Razão Social
              </dt>
              <dd
                className="text-[#EAEAEA] leading-snug"
                data-testid="franchise-legal-name"
              >
                {legal_name}
              </dd>
            </div>
          )}

          {cnpj && (
            <div>
              <dt className="text-[10px] font-mono uppercase tracking-widest text-neutral-600 mb-1">
                CNPJ
              </dt>
              <dd
                className="text-[#EAEAEA] font-mono"
                data-testid="franchise-legal-cnpj"
              >
                {cnpj}
              </dd>
            </div>
          )}

          {directors && directors.length > 0 && (
            <div>
              <dt className="text-[10px] font-mono uppercase tracking-widest text-neutral-600 mb-1">
                {directors.length > 1 ? 'Diretores' : 'Diretor(a)'}
              </dt>
              <dd
                className="text-[#EAEAEA] leading-snug"
                data-testid="franchise-legal-directors"
              >
                {directors.join(' · ')}
              </dd>
            </div>
          )}
        </dl>
      </div>
    </section>
  );
};
